
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The hero banner is a large, eye-catching banner stretching the full width of the page. A hero banner can have different appearances depending on the background chosen, the alignment of the text box and whether a description is used within the text box. There is always a call-to-action button to invite the user to go to a page with more info on the subject.`}</p>
    <p><img parentName="p" {...{
        "src": "https://inno-ecl.s3.amazonaws.com/media/images/EC/Hero%20Banner/Hero%20Banner01.jpg",
        "alt": "hero banner"
      }}></img></p>
    <p>{`Hero banner images have an aspect ratio of 3:1, meaning the with will be always three times the hight of the images;`}</p>
    <p><img parentName="p" {...{
        "src": "https://inno-ecl.s3.amazonaws.com/media/images/EC/Hero%20Banner/Hero%20Banner02.png",
        "alt": "hero banner 2"
      }}></img></p>
    <h2>{`Mobile version`}</h2>
    <p>{`On the mobile version, the text box drops below the image.`}</p>
    <p><img parentName="p" {...{
        "src": "https://inno-ecl.s3.amazonaws.com/media/images/EC/Hero%20Banner/Hero%20Banner03.png",
        "alt": "mobile version of hero banner"
      }}></img></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Components`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Use`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Requirement`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Link`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`hero image`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`optional`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`choice of 2 background colours when no image`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`no`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`description`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`optional`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`100-150 characters maximum, including punctuation.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`no`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`call to action button`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`mandatory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`3-word max – 25 characters maximum, including punctuation`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`yes`}</td>
        </tr>
      </tbody>
    </table>
    <h2>{`When to use it`}</h2>
    <p>{`The hero banner is only to be used on campaign pages when there is a strong message to communicate to your users.`}</p>
    <p>{`The image should be:`}</p>
    <ul>
      <li parentName="ul">{`relevant`}</li>
      <li parentName="ul">{`high quality`}</li>
      <li parentName="ul">{`emotionally persuasive`}</li>
    </ul>
    <h2>{`When not to use it`}</h2>
    <p>{`Large images can be intrusive and overwhelming, especially if they are intended to stay for a long time. In this case, users will not be engaged by the visual element, and will most likely not visit the site anymore.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;